import { ITask } from "../GorevYoneticisiTypes";
import { AbstractTaskHandler } from "./AbstractTaskHandler";
import { TaskDurum } from "../../../enum/TaskDurum";
import { TaskResult } from "../../../enum/TaskResult";
import TakipSenkronize from "@/plugins/uyap-plugin/takip_ac/TakipSenkronize";

export class TebligatSenkronTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            // Görev verisinden takip bilgilerini alalım
            const takipId = task.data?.takip_id;
            const dosyaEsasNo = task.data?.dosya_esas_no;
            const icraDairesi = task.data?.icra_dairesi || task.data?.ozel_icra_dairesi_isim;
            
            if (!takipId || !dosyaEsasNo || !icraDairesi) {
                task.status = TaskDurum.BITTI_HATALI;
                task.description = "Tebligat senkronizasyonu için gerekli bilgiler eksik.";
                task.result = TaskResult.fail;
                return task;
            }

            // Senkronizasyon işlemcisini başlatalım
            const senkronize = new TakipSenkronize();
            
            // UYAP'tan tebligat verilerini çekelim
            const result = await senkronize.runQueryForSelectedItems([{
                dosya_esas_no: dosyaEsasNo,
                icra_dairesi: icraDairesi,
                takip_id: takipId
            }]);

            // Senkronizasyon başarılı
            task.status = TaskDurum.BITTI_BASARILI;
            task.response = result;
            task.description = "Tebligat senkronizasyonu tamamlandı.";
            task.result = TaskResult.success;
            
            // Senkronizasyon sonuç bilgilerini kaydedelim
            if (result && result.length > 0) {
                task.response = {
                    sonuc: "Tamamlandı",
                    tebligatSayisi: result.length,
                    detaylar: result
                };
            } else {
                task.response = {
                    sonuc: "Tebligat bulunamadı",
                    tebligatSayisi: 0
                };
            }
            
            return task;
        } catch (e) {
            task.status = TaskDurum.BITTI_HATALI;
            task.result = TaskResult.fail;
            
            // Hata durumunda uygun bir mesaj hazırlayalım
            if (e instanceof Error) {
                task.description = e.message;
            } else {
                task.description = "Tebligat senkronizasyonu sırasında beklenmeyen bir hata oluştu.";
            }
            
            return task;
        }
    }
}